const config = {
    API_URL: 'https://apiclasificaods.espol.edu.ec',
  };
  
  export default config;